(function () {
    'use strict';

    var seatNumberUnique = {
        template: '',
        controller: seatNumberUniqueController,
        controllerAs: 'vm',
        require: {
            model: "ngModel"
        },
        bindings: {
            indexSeat: "<",
            formName: '<',
            isSeatHeader: '<',
            onSuccessValidate: '&',
            cabin: '<'
        }
    }

    angular
        .module('completeAir')
        .component('seatNumberUnique', seatNumberUnique);

    seatNumberUniqueController.$inject = ['$element', '$timeout'];

    function seatNumberUniqueController($element, $timeout) {
        var vm = this;
        vm.value = "";

        vm.$onInit = function () {
            var input = $element.parent(),
                inputJQ = input.find('.form-control');

            inputJQ.keydown(function () {
                $timeout(function () {
                    vm.value = vm.model.$viewValue;

                    if (vm.value !== undefined && vm.value !== "") {
                        if (vm.isSeatHeader) {
                            var isSeatHeaderNumber = vm.thereHeaderSeatNumber(vm.value, vm.indexSeat, vm.cabin.row);
                            if (!isSeatHeaderNumber) {
                                vm.formName.$setValidity('uniqueHeaderSeatNumber', true);
                            } else {
                                vm.formName.$setValidity('uniqueHeaderSeatNumber', false);
                            }
                        } else {
                            var isSeatNumber = vm.thereSeatNumber(vm.value, vm.indexSeat);

                            if (!isSeatNumber) {
                                vm.formName.$setValidity('uniqueSeatNumber', true);
                            } else {
                                vm.formName.$setValidity('uniqueSeatNumber', false);
                            }
                        }
                    }
                });
            });
        };

        vm.thereSeatNumber = function (seatNumber, indexSeat) {
            var res = false;
            for (var j = 0; j < vm.cabin.seats.length; j++) {
                var seat = vm.cabin.seats[j];
                if(indexSeat !== j) {
                    if (seat.number === seatNumber) {
                        res = true;
                    }
                }
            }
            return res;
        }

        vm.getRowSeatNumbers = function (seatNumber, indexSeat) {
            var index = indexSeat;
            var cont = 0;
            var seatNumbers = [];
            for (var j = 0; j < vm.cabin.seats.length; j++) {
                if(index === j && cont < vm.cabin.row) {
                    var newSeatNumber = seatNumber + '' + (cont + 1);
                    seatNumbers.push(newSeatNumber);
                    index++;
                    cont++;
                }
            }
            return seatNumbers;
        }

        vm.thereHeaderSeatNumber = function (seatNumber, indexSeat, cabinRow) {
            var res = false;
            var index = indexSeat;
            var seatNumbers = vm.getRowSeatNumbers(seatNumber, indexSeat);

            for (var i = 0; i < cabinRow; i++) {
                res = vm.thereSeatHeader(index,seatNumbers[i]);
                if (res) {
                    break;
                }
                index++;
            }
            return res;
        }

        vm.thereSeatHeader = function (indexSeat, seatNumber) {
            var res = false;
            for (var j = 0; j < vm.cabin.seats.length; j++) {
                var seat = vm.cabin.seats[j];

                if(indexSeat !== j ) {
                    if(seat.number === seatNumber) {
                        res = true;
                        break;
                    }
                }
            }
            return res;
        }
    }
})();

